/**
 * Admin Regions Page
 * Manage geographic regions and factory assignments
 */

import { createFileRoute } from '@tanstack/react-router'
import { RegionsSection } from '@ufc/domains/regions'

export const Route = createFileRoute('/admin/regions')({
  component: RegionsPage,
})

function RegionsPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <RegionsSection />
    </div>
  )
}
